// extracted by mini-css-extract-plugin
module.exports = {"root":"_f0feda"};